import { useRef, useState } from "react";

import { useClickOutside } from "./Shell";

export interface RowMenuItem {
  label: string;
  onClick: () => void;
  danger?: boolean;
}

/** ⋯ on a meeting's row: what you can do with it without opening it. Used on
 * the Meetings list and a project's meetings. */
export function RowMenu({ items }: { items: RowMenuItem[] }) {
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLDivElement>(null);
  useClickOutside(box, open, () => setOpen(false));
  if (items.length === 0) return <span />;
  return (
    <div className={`row-menu${open ? " open" : ""}`} ref={box}>
      <button className="row-more" aria-label="More" aria-haspopup="menu" aria-expanded={open}
              onClick={() => setOpen((was) => !was)}>
        ⋯
      </button>
      {open && (
        <div className="menu" role="menu">
          {items.map((item) => (
            <button key={item.label} role="menuitem" className={`menu-item${item.danger ? " danger" : ""}`}
                    onClick={() => {
                      setOpen(false);
                      item.onClick();
                    }}>
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
